// src/components/Sidebar.js
import React from 'react';
import { event } from '../utils/gtm';

const Sidebar = ({ setActiveTool, location, isMobileNavOpen, setIsMobileNavOpen }) => {

  const activeTool = location.pathname.substring(1);

  const handleNavClick = (tool) => {
    event({ action: 'click_nav', category: 'Navigation', label: `Sidebar: ${tool}` });
    setActiveTool(tool); // This is the navigate function
    setIsMobileNavOpen(false); // Always close on mobile after click
  };

  return (
    <nav
      className={`bg-gray-900/30 backdrop-blur-lg border-r border-white/10 flex-shrink-0
        fixed top-[70px] left-0 h-[calc(100vh-70px)] z-30
        transition-transform -translate-x-full md:translate-x-0
        ${isMobileNavOpen ? 'translate-x-0 w-60' : 'w-[70px]'}`}
    >
      <ul className="p-2 flex flex-col gap-2 mt-4">
        <li 
          className={`w-full h-14 flex items-center rounded-lg cursor-pointer transition-colors duration-200 px-4 ${
            activeTool === 'keyword-research' 
            ? 'bg-[#1d94d0] text-white' 
            : 'text-gray-400 hover:bg-gray-700/50 hover:text-white'
          } ${isMobileNavOpen ? 'justify-start gap-4' : 'justify-center'}`}
          onClick={() => handleNavClick('keyword-research')}
          title="Keyword Research"
        >
          <svg className="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" /></svg>
          <span className={`${isMobileNavOpen ? 'inline' : 'hidden'}`}>Keyword Research</span>
        </li>
        <li 
          className={`w-full h-14 flex items-center rounded-lg cursor-pointer transition-colors duration-200 px-4 ${
            activeTool === 'channel-analyzer' 
            ? 'bg-[#1d94d0] text-white' 
            : 'text-gray-400 hover:bg-gray-700/50 hover:text-white'
          } ${isMobileNavOpen ? 'justify-start gap-4' : 'justify-center'}`}
          onClick={() => handleNavClick('channel-analyzer')}
          title="Channel Analyzer"
        >
          <svg className="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
          </svg>
          <span className={`${isMobileNavOpen ? 'inline' : 'hidden'}`}>Channel Analyzer</span>
        </li>
        <li 
          className={`w-full h-14 flex items-center rounded-lg cursor-pointer transition-colors duration-200 px-4 ${
            activeTool === 'script-intelligence' 
            ? 'bg-[#1d94d0] text-white' 
            : 'text-gray-400 hover:bg-gray-700/50 hover:text-white'
          } ${isMobileNavOpen ? 'justify-start gap-4' : 'justify-center'}`}
          onClick={() => handleNavClick('script-intelligence')}
          title="Script Intelligence"
        >
          <svg className="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <span className={`${isMobileNavOpen ? 'inline' : 'hidden'}`}>Script Intelligence</span>
        </li>
      </ul>
    </nav>
  );
};

export default Sidebar;